// src/api/abonnements.api.ts — SCE Issues
// Le réglage « M'abonner aux problèmes que je déclare » (29/10) : bloc
// `abonnements` du JSON Prefs de la ligne de la personne (SCE_UserPrefs), écrit
// sans toucher aux autres blocs. Règles : utils/abonnements.

import { ecrireBlocPrefs, lireBlocPrefs } from './userPrefs.api'
import { CLE_BLOC_ABONNEMENTS, lireReglageAbonnements, type ReglageAbonnements } from '@/utils/abonnements'

export async function lireReglageAbonnementsDe(upn: string): Promise<ReglageAbonnements> {
  return lireReglageAbonnements(await lireBlocPrefs(upn, CLE_BLOC_ABONNEMENTS))
}

export async function enregistrerReglageAbonnements(upn: string, mesDeclarations: boolean): Promise<void> {
  const reglage: ReglageAbonnements = { version: 1, mesDeclarations }
  await ecrireBlocPrefs(upn, CLE_BLOC_ABONNEMENTS, reglage)
}
